import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const TransferIcon = createSvgIcon(
  <>
    <rect
      x="24"
      y="24"
      width="24"
      height="24"
      transform="rotate(-180 24 24)"
      fill="var(--background-paper)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2929 20.2929C14.9024 20.6834 14.9024 21.3166 15.2929 21.7071C15.6834 22.0976 16.3166 22.0976 16.7071 21.7071L20.7071 17.7071C21.0976 17.3166 21.0976 16.6834 20.7071 16.2929L16.7071 12.2929C16.3166 11.9024 15.6834 11.9024 15.2929 12.2929C14.9024 12.6834 14.9024 13.3166 15.2929 13.7071L17.5858 16L4 16C3.44772 16 3 16.4477 3 17C3 17.5523 3.44772 18 4 18L17.5858 18L15.2929 20.2929ZM8.70711 3.70711C9.09763 3.31658 9.09763 2.68342 8.70711 2.29289C8.31658 1.90237 7.68342 1.90237 7.29289 2.29289L3.29289 6.29289C2.90237 6.68342 2.90237 7.31658 3.29289 7.70711L7.29289 11.7071C7.68342 12.0976 8.31658 12.0976 8.70711 11.7071C9.09763 11.3166 9.09763 10.6834 8.70711 10.2929L6.41421 8L20 8C20.5523 8 21 7.55229 21 7C21 6.44772 20.5523 6 20 6L6.41421 6L8.70711 3.70711Z"
      fill="currentColor"
    />
  </>,
  "TransferIcon"
);
